import { AddressBookSection } from "../../../addresses/components/address-book-section";
import { useCheckoutStore } from "../../domain/useCheckoutStore";

/**
 * Checkout-specific wrapper that connects the generic `AddressBookSection`
 * to the checkout store's `shippingAddressId`. The generic component owns
 * fetching, listing, archiving, and inline-add; this file just wires
 * selection state.
 */
export function DeliveryAddressSection() {
  const { shippingAddressId, setShippingAddressId } = useCheckoutStore();
  return (
    <AddressBookSection
      type="delivery"
      selectedId={shippingAddressId}
      onSelect={setShippingAddressId}
    />
  );
}
